import {gql} from '@apollo/client'

import {TFA_PHONE_NUMBER_FRAGMENT, PHONE_NUMBER_FRAGMENT, TFA_CONFIG_FRAGMENT, TFA_ENROLLMENT_FRAGMENT} from '../fragments/tfa'

export const CREATE_TFA_PHONE_NUMBER = gql`
  ${TFA_PHONE_NUMBER_FRAGMENT}
  mutation createTfaPhoneNumber($input: PhoneNumberInput!) {
    createTfaPhoneNumber(input: $input) {
      ...TfaPhoneNumberFragment
    }
  }
`

export const CONFIRM_PRIMARY_TFA_NUMBER = gql`
  ${TFA_PHONE_NUMBER_FRAGMENT}
  mutation confirmPrimaryTfaNumber($input: PhoneNumberConfirmationInput!, $phoneId: Int!) {
    confirmPrimaryTfaNumber(input: $input, phoneId: $phoneId) {
      ...TfaPhoneNumberFragment
    }
  }
`

export const DELETE_TFA_PHONE_NUMBER = gql`
  mutation deleteTfaPhoneNumber($phoneId: Int!) {
    deleteTfaPhoneNumber(phoneId: $phoneId) {
      message
    }
  }
`

export const UPDATE_TFA_PHONE_NUMBER_MESSAGE_MODE = gql`
  mutation updateTfaPhoneNumberMessageMode($input: TfaPhoneNumberMessageModeInput!) {
    updateTfaPhoneNumberMessageMode(input: $input) {
      id
      preferredMessageMode
    }
  }
`

export const CREATE_TFA_BACKUP_CODES = gql`
  ${PHONE_NUMBER_FRAGMENT}
  mutation createTfaBackupCodes($tfaConfigId: Int!) {
    createTfaBackupCodes(tfaConfigId: $tfaConfigId) {
      id
      userId
      status
      primaryNumber {...PhoneNumberFragment}
      secondaryNumber {...PhoneNumberFragment}
      backupCodes
    }
  }
`

export const TOGGLE_TFA_STATUS = gql`
  ${TFA_CONFIG_FRAGMENT}
  mutation toggleTfaStatus($input: TfaStatusInput!) {
    toggleTfaStatus(input: $input) {...TfaConfigFragment}
  }
`

export const CREATE_TFA_ENROLLMENT = gql`
  ${TFA_ENROLLMENT_FRAGMENT}
  mutation createTfaEnrollment($input: TfaEnrollmentInput!) {
    createTfaEnrollment(input: $input) {...TfaEnrollmentFragment}
  }
`

export const VERIFY_TFA_ENROLLMENT = gql`
  ${TFA_ENROLLMENT_FRAGMENT}
  mutation verifyTfaEnrollment($id: ID!, $input: TfaEnrollmentVerificationInput!) {
    verifyTfaEnrollment(id: $id, input: $input) {...TfaEnrollmentFragment}
  }
`

export const DELETE_TFA_ENROLLMENT = gql`
  mutation deleteTfaEnrollment($id: ID!) {
    deleteTfaEnrollment(id: $id) {
      message
    }
  }
`
